// @wc-ignore-file
import { queryOptions } from "@tanstack/react-query";
import { listProjectJoinRequests, listWorkspaceProjects } from "./project-access-api";

export const projectAccessQueries = {
  all: () => ["project-access"] as const,
  /** CR-203 D2 discovery: every project of the workspace (not membership-scoped). */
  workspaceProjects: (workspaceId: string) =>
    queryOptions({
      queryKey: [...projectAccessQueries.all(), "workspace-projects", workspaceId] as const,
      queryFn: () => listWorkspaceProjects(workspaceId),
    }),
  /** CR-203 S3: a project's pending join requests (owner-only RPC). */
  joinRequests: (projectId: string) =>
    queryOptions({
      queryKey: [...projectAccessQueries.all(), "join-requests", projectId] as const,
      queryFn: () => listProjectJoinRequests(projectId),
      // The RPC raises for a non-owner (e.g. demoted mid-session): fail once,
      // don't burst retries before the role refresh unmounts the caller.
      retry: false,
    }),
};
